import type { PagesConfig } from '#types/config/pages'
import type { RecursivePartial } from '#types/utils'

export default {
  orderNumberLengths: (() => [8, 13]) as unknown as number[]
} satisfies RecursivePartial<PagesConfig['orderStatus']>
